'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Condition2 = require('../abstract/Condition');

var _Condition3 = _interopRequireDefault(_Condition2);

var _Predicate = require('../abstract/Predicate');

var _Predicate2 = _interopRequireDefault(_Predicate);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotCondition = function (_Condition) {
    (0, _inherits3.default)(NotCondition, _Condition);

    function NotCondition() {
        (0, _classCallCheck3.default)(this, NotCondition);
        return (0, _possibleConstructorReturn3.default)(this, (NotCondition.__proto__ || (0, _getPrototypeOf2.default)(NotCondition)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotCondition, [{
        key: 'addChild',
        value: function addChild(child) {
            if (this.children.length >= 1) {
                throw new Error('Cannot have more than one child for NotCondition.');
            }
            (0, _get3.default)(NotCondition.prototype.__proto__ || (0, _getPrototypeOf2.default)(NotCondition.prototype), 'addChild', this).call(this, child);
        }
    }, {
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            if (this.children.length !== 1) {
                throw new Error('Cannot convert not predicate without a node to negate.');
            } else {
                return { $not: this.children[0].toQueryFragment() };
            }
        }
    }]);
    return NotCondition;
}(_Condition3.default);

NotCondition.accepts = [_Condition3.default, _Predicate2.default];
NotCondition.canHaveChildren = true;
NotCondition.terminalNode = false;
NotCondition.displayName = 'Not Condition';

_QueryNodeRegistry2.default.register(NotCondition);
exports.default = NotCondition;